<mat-card appearance="outlined" [formGroup]="formGroup">
  <mat-card-header>
    <mat-card-title>Your customer details</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <div class="row">
      <div class="col-sm-4">
        <mat-form-field appearance="outline" class="example-full-width">
          <input matInput placeholder="Contact name" formControlName="name">
          <mat-error>
            <app-validation-partial
              [formGroup]="formGroup"
              [fieldName]="'name'">
            </app-validation-partial>
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col-sm-4">

        <fmc-sensis-email
          [parentFormGroup]="formGroup"
          [controlName]="'email'"
          [placeholderText]="'Email address'"
        ></fmc-sensis-email>

      </div>
      <div class="col-sm-4">

        <fmc-sensis-mobile
          [parentFormGroup]="formGroup"
          [controlName]="'phone'"
          [placeholderText]="'Phone number'"
        ></fmc-sensis-mobile>

      </div>
    </div>
  </mat-card-content>
</mat-card>
